import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as moment from 'moment';
import { Common } from 'src/app/Module/Shared/Utility/Common';
import { CustomerMeetingService } from 'src/app/Module/Core/CustomerMeeting/CustomerMeeting.service';
//import { CustomerMeetingService } from '../CustomerMeeting.service';
import { map } from 'rxjs/operators';
import { SHowCFPPService } from '../../ContactPopup/SHowCFPP.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-CDPlanAppointment',
  templateUrl: './CDPlanAppointment.component.html'
})
export class CDPlanAppointmentComponent implements OnInit,OnDestroy {

  dropdownSettings: IDropdownSettings = { idField: 'id', textField: 'name', enableCheckAll: false };
  @Input() contactList: any = "";
  @Input() dealList: any = "";
  @Input() customerid: any = "";
  @Input() meetingTypeList: any = "";
  @Input() action_id: any =0;
  @Input() qCalenderDate: any = "";
  categorytype;
  minDate: Date = new Date();
  maxDate: any = "";
  @Output() CallParent: EventEmitter<any> = new EventEmitter();
  VP_Subscription: Subscription;
  constructor(  private checkinServiceapi: CustomerMeetingService, private SHowCFPPService: SHowCFPPService) { }
  ngOnInit() {
   // this.Show(1, 2, 1, Common.deal_stage, this.dealList);
   this.VP_Subscription = this.checkinServiceapi.api.ContactPopupService.save_info.subscribe(
    (value) => {
      if(value.customr_id==this.customerid){
        this.Submit(value. ret);
       // this.contactList =value. ret.contactsList.filter((y)=>{return y.id!=-99});
      }
    });
  }

  ngOnDestroy(){
    this.VP_Subscription.unsubscribe();
  }

  state = {
    deal: { value: 0, iserr: false, err_txt: "" },
    whomtomeet: { value: 0, iserr: false, err_txt: "" },
    meetingdate: { value: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), iserr: false, err_txt: "" },
    meetingType: { value: 0, iserr: false, err_txt: "" },
    area: { value: "", iserr: false, err_txt: "" },
    comments: { value: "", iserr: false, err_txt: "" },
  }
  _show = false; SelectedMeetingList = []; SelectedDealList = [];isAppointmentAreaFLG:boolean = false;
  _id = 0; _s_id = 0;
  drpDealList:any = [];

  Show(id, s_id,action_id,allowed_deal, deallist: any = "",contactlist) {
    //this.categorytype = this.checkinServiceapi.api.GetCategory();
    this.isAppointmentAreaFLG = this.checkinServiceapi.api.GetisAppointmentArea();
    //console.log('this.categorytype',this.categorytype);
    this.contactList=contactlist;
    console.log("allowed_deal",allowed_deal)
    if(deallist != "")
    {
      this.drpDealList = deallist;
    }
    this._id = id;
    this._s_id = s_id;
    console.log("s_id",s_id)
    this._show = true;

    console.log("this.dealList",this.dealList)
    this.drpDealList = Common.AllowedDeal( this.dealList,allowed_deal);
    this.LoopList = [];
    if(this.qCalenderDate != '')
    {
      let currentDateOnly: any = (moment(new Date()).format("YYYY-MM-DD"));

      if(currentDateOnly == this.qCalenderDate) //current date
      {
        //min date and state meetingdate will be taken as default
        this.maxDate = new Date();
      }
      else
      {
        this.state.meetingdate.value = this.qCalenderDate;
        this.minDate = this.qCalenderDate;
        this.maxDate = this.qCalenderDate;
      }


    }

    if(this.drpDealList.length>0){
      this.drpDealList.push({ id: -1, name: "Other",SelectedMeetingList:[] })
    }
  else{
    let _deal:any ={ id: -1, name: "Other" };
    _deal.state = Common.JSON_copy(this.state);
    _deal.SelectedMeetingList = [];
    _deal.cbxSameasabove=false;
    this.LoopList.push(_deal)
    console.log('_deal.state', _deal.state);
    console.log('this.LoopList', this.LoopList);
  }
  console.log('this.contactList', this.contactList);
  console.log('this.LoopList', this.LoopList);
  //this.contactList.map((x)=>{x.id=parseInt(x.id);x.designation="";x.code=0;});
  console.log('this.dropdownSettings', this.dropdownSettings);
  console.log('this.LoopList', this.LoopList);

    this.SelectedDealList = [];

    this.action_id=action_id;



  }
  LoopList: any = [];
  DealAddSelect(item) {
    let _deal = Common.JSON_copy(item);
    _deal.state = Common.JSON_copy(this.state);
    _deal.SelectedMeetingList = [];
    _deal.cbxSameasabove=false;
    this.LoopList.push(_deal);
    setTimeout(() => {  Common._$("#drpdeal").trigger('click');     });
  }
  cbxsameasabove = false;
  SameasAbove(obj,ind) {
    if (obj.cbxSameasabove) {
      obj.state = this.LoopList[ind-1].state;
      obj.SelectedMeetingList = this.LoopList[ind-1].SelectedMeetingList;
    } else {
      this.LoopList.map((x, ind) => {
        if (ind != 0) {
          x.state = Common.JSON_copy(this.state);
          x.SelectedMeetingList = [];
        }
      })
    }
  }
  DealRemoveSelect(item) {
    let _temp = [];
    this.LoopList.map((x) => {
      if (x.id != item.id) {
        _temp.push(x);
      }
    })
    this.LoopList = _temp;
  }

  Close() {
    this._show = false;
    this.Callparentfunc(0);
  }
  Cancel() {
    this.LoopList.map((x)=>{
      x.state.meetingdate.iserr = false;
      x.state.meetingType.iserr = false;
      x.state.area.iserr = false;

      x.state.whomtomeet.iserr = false;
      x.state.meetingdate.value = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      x.state.meetingType.value = 0;
      x.state.area.value ="";

      x.state.whomtomeet.value = 0;
      x.SelectedMeetingList=[];
      x.state.comments.value ="";
    })

  }
  Save() {
    let isvalid = true;
    let _isFocus = false;
    this.state.deal.iserr = false;
    if ( this.LoopList.length==0) {
      this.state.deal.iserr = true; this.state.deal.err_txt = "Select Deal";
      isvalid = false;
      if (!_isFocus) { Common.StarrPPfocus("div_deal"); _isFocus = true; }
    }
    this.LoopList.map((x, ind) => {
      x.state.meetingdate.iserr = false;
      x.state.meetingType.iserr = false;
      x.state.area.iserr = false;

      x.state.whomtomeet.iserr = false;

      if (!x.state.meetingType.value  || x.state.meetingType.value == 0) {
        x.state.meetingType.iserr = true; x.state.meetingType.err_txt = "Select Meeting Type";
        isvalid = false;
        if (!_isFocus) { Common.StarrPPfocus("div_mt_" + ind); _isFocus = true; }
      }

      if (x.state.meetingdate.value == "") {
        x.state.meetingdate.iserr = true; x.state.meetingdate.err_txt = "Enter meeting date";
        isvalid = false;
        if (!_isFocus) { Common.StarrPPfocus("div_m_" + ind); _isFocus = true; }
      }
      if (this.isAppointmentAreaFLG && x.state.area.value == "") {
        x.state.area.iserr = true; x.state.area.err_txt = "Select area";
        isvalid = false;
        if (!_isFocus) { Common.StarrPPfocus("div_ar_" + ind); _isFocus = true; }
      }

      // if (x.SelectedMeetingList.length == 0) {
      //   x.state.whomtomeet.iserr = true; x.state.whomtomeet.err_txt = "Select Whom To Meet ";
      //   isvalid = false;
      //   if (!_isFocus) { Common.StarrPPfocus("div_c_" + ind); _isFocus = true; }
      // }


    });

    if (isvalid) {
     // console.log("this.LoopList", this.LoopList)
      let _s_data:any=[];
      this.LoopList.map((y) => {
        let _data: any = {
          When: moment(y.state.meetingdate.value).format("YYYY-MM-DD HH:mm:ss"),
          When_format: moment(y.state.meetingdate.value).format("YYYY-MM-DD"),          
          personmet:   y.SelectedMeetingList.map((x) => { return x.id }).join(","),
          meetingType: y.state.meetingType.value,
          area: this.isAppointmentAreaFLG  ? y.state.area.value: "On premises",
          comments: y.state.comments.value,
          SelectedMeetingList:this.GetSelContactList(y),

        };
        _s_data.push({ id:y.id,name:y.name,data:_data,action_id:this.action_id, is_deal:this.drpDealList.length>0?true:false
          ,sameasabove:y.cbxSameasabove         })
      })
      this.Callparentfunc(1, _s_data);
      console.log('_s_data',_s_data);
      this._show = false;
    }
  }

  GetSelContactList(y){
    let _sel_contact_list=[];
        y.SelectedMeetingList.map((x) => {
          let _f= this.contactList.filter((y)=>{ return y.id==x.id });
         if(_f.length>0){
          _sel_contact_list.push(_f[0])
         }
        })
        return _sel_contact_list;
  }

  Callparentfunc(status, data = '') {
    this.CallParent.emit({ status: status, data: data, id: this._id, s_id: this._s_id  ,clist:this.contactList });
  }
  Callopen_cal(pic) {
    setTimeout(() => { pic.open() }, 100);
  }

  Showdrp = true;
  ResetMultiselect() {
    this.dropdownSettings = this.dropdownSettings;
    this.Showdrp = false;
    setTimeout(() => { this.Showdrp = true; });
  }

  showContactPopup = false; Select_ind = 0;
  onItemSelect(item: any, ind) {
    console.log('onItemSelect: ', item);
    console.log('onItemSelect id: ', item.id);
    //console.log(this.SelectedMeetingList);
    if (item.id != '0' && item.id == '-99') {
      this.Select_ind = ind;
      this.checkinServiceapi.api.ShowContatPoppup(this.customerid,this.contactList);
    }
    this.LoopList.map((x) => {
      x.SelectedMeetingList = x.SelectedMeetingList.filter((y) => { return y.id != "-99" })
    });
    setTimeout(() => {  Common._$("#divmsel_"+ind).trigger('click');     });
    // console.log(" this.SelectedMeetingList", this.SelectedMeetingList)
  }
  async Submit_Event($event){
    alert("hi")
  }
  async Submit($event) {
    console.log("Submit obj", $event)
    this.showContactPopup = false
    this.contactList = $event.dropdownList;
    this.LoopList.map((x, ind) => {
      x.contactList = $event.dropdownList;
      if (this.Select_ind == ind) {
        let _p = $event.contactsList.filter((y) => { return y.new_added == 1 });
        console.log("Adddes", this.SelectedMeetingList)
        _p.map((y) => { x.SelectedMeetingList.push({ id: y.id, name: y.name }) })
      }
    });
  //  Common.StarrPPfocus("div_c_" + this.Select_ind)
    //console.log("Adddes 123", this.SelectedMeetingList)
    this.ResetMultiselect();
  }
  MFocus(id,ind){
    Common.StarrPPfocus(id+ind);
  }
}
